(function () {
  class LowSymbolAnimator extends PIXI.Container {
    constructor() {
      super();
      this.visible = false;
      this._trackInfo = undefined;
      this._animTime = 700;
      this._movieScale = { x: 1.0, y: 1.0 };
    }

    play(trackInfo, loop, onCellAnimFinishedCb) {
      this._trackInfo = trackInfo;
      this.initialiseSymbolMovie(trackInfo.symbolId, trackInfo.getPosition());
      trackInfo.showSymbol(false);

      let self = this;
      timerManager.addTimer(
        this._animTime,
        function (progress) {
          let scale = 1 + Math.sin(Math.PI * progress) * 0.25;
          self._movie.scale.set(
            self._movieScale.x * scale,
            self._movieScale.y * scale
          );
        },
        function () {
          self._movie.scale.set(self._movieScale.x, self._movieScale.y);
          onCellAnimFinishedCb(self);
        }
      );
    }

    initialiseSymbolMovie(symbolId, symPos) {
      this.visible = true;
      this._movie.gotoAndStop(symbolId);
      this.position.set(
        symPos.x + this._positionOffset.x,
        symPos.y + this._positionOffset.y
      );
    }

    getTrackInfo() {
      return this._trackInfo;
    }

    finalise() {
      this.visible = false;
      this._trackInfo.showSymbol(true);
      this._trackInfo = undefined;
    }

    untrack() {
      if (this._trackInfo) {
        this._trackInfo.untrack();
      }
    }

    skip() {
      this.untrack();
    }

    onOrientationChange() {
      if (this._trackInfo !== undefined) {
        let symPos = this._trackInfo.getPosition();
        this.position.set(
          symPos.x + this._positionOffset.x,
          symPos.y + this._positionOffset.y
        );
        this._movie.scale.set(this._movieScale.x, this._movieScale.y);
      }
    }
  }

  let create = function () {
    return new LowSymbolAnimator();
  };

  let initialise = function (json, instance) {
    instance._movie = resourceManager.createObject(
      "movie",
      "staticSymbols",
      instance.name,
      {
        definition: "staticSymbols",
      }
    );
    instance._positionOffset = { x: 0, y: 0 };
    if (json.playData.posOffset) {
      instance._positionOffset = json.playData.posOffset;
    }
    if (json.playData.scale) {
      instance._movieScale = {
        x: json.playData.scale.x,
        y: json.playData.scale.y,
      };
      instance._movie.scale.set(json.playData.scale.x, json.playData.scale.y);
    }
    if (json.playData.animTime) {
      instance._animTime = json.playData.animTime;
    }
    instance._movie.anchor.set(0.5);
  };

  let getRequiredFiles = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "LowSymbolAnimatorEx",
    create,
    initialise,
    getRequiredFiles
  );
})();
